import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.checklist.result');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;
declare let wiz: any;

interface AnswerData {
    value: string;
    opinion: string;
    repair_needed: string;
    grade: string;
    not_applicable: boolean;
    rating: string;
}

interface SportsGroup {
    title: string;
    good_multiplier: number;
    fair_multiplier: number;
    poor_multiplier: number;
    sections: any[];
    totalItems: number;
}

// 정기안전점검 점수 산정 상수
const GRADE_VALUES: { [key: string]: number } = { a: 10, b: 8, c: 5, d: 2, e: 0 };
const INSPECTION_CATEGORY_WEIGHTS: { [key: string]: number } = {
    '주요시설': 60,
    '일반시설': 20,
    '부대시설': 20,
};

const INSPECTION_NOTES: { [key: string]: string[] } = {
    bridge: [
        '※ 출렁다리는 해당 시설물 특성에 부합하는 평가항목을 적용하여 평가를 실시한다.',
        '※ 정기안전점검 실시결과와 상태변화(손상, 결함) 등의 정도, 위치, 형상, 진행성 등을 상세히 기술',
        '※ 점검로는 설치 유무 및 책임기술자 판단에 따라 보수의 필요성 여부도 기술',
        '※ 중대한 결함 등(공중이 이용하는 부위)의 판정은 "세부지침(안전점검·진단편)" 시설물편 제1장 1.1.4. 중대한 결함 등의 정도"에서 정한 내용을 참조한 부록을 따라 평가를 실시한다.',
        '※ 해당없음 : 평가부재가 없는 경우에 한함',
    ],
    tunnel: [
        '※ 정기안전점검 실시결과와 상태변화(손상, 결함) 등의 정도, 위치, 형상, 진행성 등을 상세히 기술',
        '※ 환기구 및 점검로는 설치 유무 및 책임기술자 판단에 따라 보수의 필요성 여부도 기술',
        '※ 중대한 결함 등(공중이 이용하는 부위)의 판정은 "세부지침(안전점검·진단편)" 시설물편 제2장 2.1.4. 중대한 결함 등의 정도"에서 정한 내용을 참조한 부록을 따라 평가를 실시한다.',
        '※ 해당없음 : 평가부재가 없는 경우에 한함',
    ],
    retaining_wall: [
        '※ 평가 시 제외항목 — 콘크리트옹벽: 3항목, 6~9항목, 11항목 / 보강토옹벽: 2항목, 5항목, 7~9항목, 12항목 / 석축: 2항목, 5항목, 7~8항목 / 돌망태옹벽: 1~6항목, 11~12항목',
        '※ 정기안전점검 실시결과와 상태변화(손상, 결함) 등의 정도, 위치, 형상, 진행성 등을 상세히 기술',
        '※ 환기구 및 점검로는 설치 유무 및 책임기술자 판단에 따라 보수의 필요성 여부도 기술',
        '※ 중대한 결함 등(공중이 이용하는 부위)의 판정은 "세부지침(안전점검·진단편)" 시설물편 제13장 13.1.4. 중대한 결함 등의 정도"에서 정한 내용을 참조한 부록을 따라 평가를 실시한다.',
        '※ 해당없음 : 평가부재가 없는 경우에 한함',
    ],
    cut_slope: [
        '※ 정기안전점검 실시결과와 상태변화(손상, 결함) 등의 정도, 위치, 형상, 진행성 등을 상세히 기술',
        '※ 점검로는 설치 유무 및 책임기술자 판단에 따라 보수의 필요성 여부도 기술',
        '※ 중대한 결함 등(공중이 이용하는 부위)의 판정은 "세부지침(안전점검·진단편)" 시설물편 제14장 14.1.4. 중대한 결함 등의 정도"에서 정한 내용을 참조한 부록을 따라 평가를 실시한다.',
        '※ 해당없음 : 평가부재가 없는 경우에 한함',
    ],
    building: [
        '※ 마감재는 광고판, 옥상 파라펫 등 건축물에 설치되어 탈락·낙하 위험이 있는 설치물을 포함한다.',
        '※ 정기안전점검 실시결과와 상태변화(손상, 결함) 등의 정도, 위치, 형상, 진행성 등을 상세히 기술',
        '※ 환기구 및 점검로는 설치 유무 및 책임기술자 판단에 따라 보수의 필요성 여부도 기술',
        '※ 중대한 결함 등(공중이 이용하는 부위)의 판정은 "세부지침(안전점검·진단편)" 시설물편 제6장 6.1.4. 중대한 결함 등의 정도"에서 정한 내용을 참조한 부록을 따라 평가를 실시한다.',
        '※ 해당없음 : 평가부재가 없는 경우에 한함',
    ],
};

@Component({
    selector: 'wiz-page-checklist-result',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.checklist.result/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

@media print {
  :host {
    height: auto;
  }
  /* A4 세로 페이지 설정 */
  @page {
    size: A4 portrait;
    margin: 15mm;
  }
  /* 테이블 행 짤림 방지 */
  tr {
    page-break-inside: avoid;
  }
  /* 평가결과 영역 페이지 나눔 방지 */
  .bg-white {
    page-break-inside: avoid;
  }
}`],
})
export class PageChecklistResultComponent implements OnInit {
    public responseId: string = '';
    public response: any = {};
    public checklist: any = {};
    public facility: any = null;
    public sections: any[] = [];
    public answers: { [itemId: string]: AnswerData } = {};
    public isInspection: boolean = false;
    public isSports: boolean = false;
    public sportsGroups: SportsGroup[] = [];

    // 정기안전점검 점수 산정
    public inspectionScoreCategories: any[] = [];
    public inspectionTotalScore: number = 0;
    public inspectionGrade: string = '';

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.responseId = WizRoute.segment.responseId || '';

        if (!this.responseId) {
            this.service.href('/checklist/list');
            return;
        }

        await this.loadResult();
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    public async loadResult() {
        const { code, data } = await wiz.call('load_result', { response_id: this.responseId });
        if (code !== 200) {
            this.service.href('/checklist/list');
            return;
        }

        this.response = data.response;
        this.checklist = data.checklist;
        this.facility = data.facility;
        this.isInspection = data.checklist.form_type === 'inspection';
        this.isSports = data.checklist.form_type === 'sports';

        // 섹션
        this.sections = (data.sections || []).map((s: any) => ({
            ...s,
            group_title: s.group_title || '',
            good_multiplier: s.good_multiplier ?? 1,
            fair_multiplier: s.fair_multiplier ?? 0.6,
            poor_multiplier: s.poor_multiplier ?? 0.4,
            items: (s.items || []).map((item: any) => ({
                ...item,
                options: Array.isArray(item.options) ? item.options : [],
                points: item.points || 0,
            }))
        }));

        // 답변
        const rawAnswers = data.answers || {};
        this.answers = {};
        for (const section of this.sections) {
            for (const item of section.items) {
                if (rawAnswers[item.id]) {
                    this.answers[item.id] = {
                        value: rawAnswers[item.id].value || '',
                        opinion: rawAnswers[item.id].opinion || '',
                        repair_needed: rawAnswers[item.id].repair_needed || '',
                        grade: rawAnswers[item.id].grade || '',
                        not_applicable: !!rawAnswers[item.id].not_applicable,
                        rating: rawAnswers[item.id].rating || '',
                    };
                } else {
                    this.answers[item.id] = { value: '', opinion: '', repair_needed: '', grade: '', not_applicable: false, rating: '' };
                }
            }
        }

        if (this.isSports) this.computeSportsGroups();
        if (this.isInspection) this.computeInspectionScore();
        this.ref.detectChanges();
    }

    // ==================== 스포츠 모드 ====================

    public computeSportsGroups() {
        const groups: SportsGroup[] = [];
        let currentGroup: SportsGroup | null = null;
        for (const section of this.sections) {
            const gt = section.group_title || section.title;
            if (!currentGroup || currentGroup.title !== gt) {
                currentGroup = {
                    title: gt,
                    good_multiplier: section.good_multiplier ?? 1,
                    fair_multiplier: section.fair_multiplier ?? 0.6,
                    poor_multiplier: section.poor_multiplier ?? 0.4,
                    sections: [],
                    totalItems: 0,
                };
                groups.push(currentGroup);
            }
            currentGroup.sections.push(section);
            currentGroup.totalItems += section.items.length;
        }
        this.sportsGroups = groups;
    }

    public getItemScore(item: any, section: any): number {
        const answer = this.getAnswer(item.id);
        if (!answer.rating) return 0;
        const points = item.points || 0;
        const multiplierMap: any = {
            good: section.good_multiplier ?? 1,
            fair: section.fair_multiplier ?? 0.6,
            poor: section.poor_multiplier ?? 0.4,
        };
        return Math.round((points * (multiplierMap[answer.rating] || 0)) * 100) / 100;
    }

    public getGroupScore(group: SportsGroup): number {
        let total = 0;
        for (const section of group.sections) {
            for (const item of section.items) {
                total += this.getItemScore(item, section);
            }
        }
        return Math.round(total * 100) / 100;
    }

    public getGroupMaxScore(group: SportsGroup): number {
        let total = 0;
        for (const section of group.sections) {
            for (const item of section.items) {
                total += item.points || 0;
            }
        }
        return total;
    }

    public get sportsTotalScore(): number {
        const stored = this.response?.total_score;
        if (stored != null && stored !== '') return stored;
        let total = 0;
        for (const section of this.sections) {
            for (const item of section.items) {
                total += this.getItemScore(item, section);
            }
        }
        return Math.round(total * 100) / 100;
    }

    public get sportsTotalMaxScore(): number {
        const stored = this.response?.max_score;
        if (stored != null && stored !== '') return stored;
        return this.sections.reduce((sum: number, s: any) =>
            sum + s.items.reduce((is: number, item: any) => is + (item.points || 0), 0), 0);
    }

    public get sportsPercentage(): number {
        const max = this.sportsTotalMaxScore;
        if (max <= 0) return 0;
        return Math.round((this.sportsTotalScore / max) * 10000) / 100;
    }

    public get sportsGrade(): string {
        const pct = this.sportsPercentage;
        if (pct >= 95) return 'A';
        if (pct >= 85) return 'B';
        if (pct >= 65) return 'C';
        return 'D';
    }

    public sportsGradeColor(grade: string): string {
        const map: any = {
            'A': 'bg-emerald-600 text-white',
            'B': 'bg-blue-600 text-white',
            'C': 'bg-yellow-500 text-white',
            'D': 'bg-red-600 text-white',
        };
        return map[grade] || 'bg-slate-200 text-slate-500';
    }

    public ratingLabel(rating: string): string {
        const map: any = { good: '양호', fair: '미흡', poor: '불량' };
        return map[rating] || '-';
    }

    public ratingColor(rating: string): string {
        const map: any = {
            good: 'bg-emerald-100 text-emerald-700',
            fair: 'bg-yellow-100 text-yellow-700',
            poor: 'bg-red-100 text-red-700',
        };
        return map[rating] || 'bg-slate-100 text-slate-500';
    }

    public getSportsItemNumber(groupIndex: number, sectionIndexInGroup: number, itemIndex: number): number {
        let count = 0;
        for (let gi = 0; gi < groupIndex; gi++) {
            count += this.sportsGroups[gi].totalItems;
        }
        for (let si = 0; si < sectionIndexInGroup; si++) {
            count += this.sportsGroups[groupIndex].sections[si].items.length;
        }
        return count + itemIndex + 1;
    }

    // ==================== 정기안전점검: 점수 산정 ====================

    public computeInspectionScore() {
        if (!this.isInspection) return;

        const catMap = new Map<string, { sections: any[] }>();
        for (const section of this.sections) {
            const catTitle = section.group_title || section.title;
            if (!catMap.has(catTitle)) {
                catMap.set(catTitle, { sections: [] });
            }
            catMap.get(catTitle)!.sections.push(section);
        }

        const categories: any[] = [];
        for (const [title, data] of catMap.entries()) {
            let sum = 0, answered = 0, itemCount = 0, naCount = 0;
            for (const section of data.sections) {
                for (const item of section.items) {
                    itemCount++;
                    const answer = this.getAnswer(item.id);
                    if (answer.not_applicable) { naCount++; continue; }
                    if (answer.grade && GRADE_VALUES[answer.grade] !== undefined) {
                        sum += GRADE_VALUES[answer.grade];
                        answered++;
                    }
                }
            }
            categories.push({
                title,
                weight: INSPECTION_CATEGORY_WEIGHTS[title] || 0,
                avg: answered > 0 ? Math.round((sum / answered) * 100) / 100 : 0,
                hasData: answered > 0,
                answeredCount: answered,
                totalCount: itemCount,
                naCount,
                adjustedWeight: 0,
                weightedScore: 0,
            });
        }

        const activeCategories = categories.filter((c: any) => c.hasData && c.weight > 0);
        const activeWeightSum = activeCategories.reduce((s: number, c: any) => s + c.weight, 0);

        for (const cat of categories) {
            if (cat.hasData && cat.weight > 0 && activeWeightSum > 0) {
                cat.adjustedWeight = Math.round(cat.weight * (100 / activeWeightSum) * 10) / 10;
                cat.weightedScore = Math.round(cat.avg * cat.adjustedWeight / 100 * 100) / 100;
            } else {
                cat.adjustedWeight = cat.weight;
                cat.weightedScore = 0;
            }
        }

        let totalScore = 0;
        if (activeWeightSum > 0) {
            for (const cat of activeCategories) {
                const adjustedWeight = cat.weight * (100 / activeWeightSum);
                totalScore += cat.avg * adjustedWeight / 100;
            }
        }
        this.inspectionTotalScore = Math.round(totalScore * 100) / 100;

        if (this.inspectionTotalScore >= 7) this.inspectionGrade = 'A';
        else if (this.inspectionTotalScore >= 6) this.inspectionGrade = 'B';
        else if (this.inspectionTotalScore >= 5) this.inspectionGrade = 'C';
        else if (this.inspectionTotalScore >= 4) this.inspectionGrade = 'D';
        else this.inspectionGrade = 'E';

        this.inspectionScoreCategories = categories;
    }

    public inspectionGradeColor(grade: string): string {
        const map: any = {
            'A': 'bg-emerald-600 text-white',
            'B': 'bg-blue-600 text-white',
            'C': 'bg-yellow-500 text-white',
            'D': 'bg-orange-600 text-white',
            'E': 'bg-red-600 text-white',
        };
        return map[grade] || 'bg-slate-200 text-slate-500';
    }

    // ==================== 공통 ====================

    public getAnswer(itemId: string): AnswerData {
        return this.answers[itemId] || { value: '', opinion: '', repair_needed: '', grade: '', not_applicable: false, rating: '' };
    }

    public getGlobalItemNumber(sectionIndex: number, itemIndex: number): number {
        let count = 0;
        for (let i = 0; i < sectionIndex; i++) {
            count += this.sections[i].items.length;
        }
        return count + itemIndex + 1;
    }

    public get totalItemCount(): number {
        return this.sections.reduce((sum: number, s: any) => sum + s.items.length, 0);
    }

    public facilityTypeLabel(type: string): string {
        const map: any = {
            bridge: '교량, 육교',
            tunnel: '터널, 지하차도',
            retaining_wall: '옹벽',
            cut_slope: '절토사면',
            building: '건축물, 지하도상가',
            soccer_field: '축구장',
            baseball_field: '야구장',
            indoor_arena: '실내경기장(배구, 농구)',
        };
        return map[type] || type || '-';
    }

    public getInspectionNotes(): string[] {
        const ftype = this.checklist?.facility_type || '';
        return INSPECTION_NOTES[ftype] || [];
    }

    public gradeLabel(grade: string): string {
        return grade ? grade.toUpperCase() : '-';
    }

    public gradeColor(grade: string): string {
        const map: any = {
            'a': 'bg-emerald-100 text-emerald-700',
            'b': 'bg-blue-100 text-blue-700',
            'c': 'bg-yellow-100 text-yellow-700',
            'd': 'bg-orange-100 text-orange-700',
            'e': 'bg-red-100 text-red-700',
        };
        return map[grade?.toLowerCase()] || 'bg-slate-100 text-slate-500';
    }

    public safetyGradeColor(grade: string): string {
        const map: any = {
            'A': 'bg-emerald-600 text-white',
            'B': 'bg-blue-600 text-white',
            'C': 'bg-yellow-500 text-white',
            'D': 'bg-orange-600 text-white',
            'E': 'bg-red-600 text-white',
        };
        return map[grade] || 'bg-slate-200 text-slate-500';
    }

    public printResult() {
        window.print();
    }

    public goBack() {
        if (this.facility?.project_id) {
            this.service.href(`/project/detail/${this.facility.project_id}`);
        } else {
            this.service.href('/checklist/list');
        }
    }
}

export default PageChecklistResultComponent;